<template>
  <div id="printm">
    <div class="common-page common-head mt20 printhide">
      <div class="common-page common-head-title">
        <div>
          <i class="icon-tr--detailed" style="padding-right: 5px"></i>
          数据图表
        </div>
        <!-- <div class="flex">
          <el-form>
            <el-form-item label="切换数据" label-width="80px">
              <el-select size="small" @change="changeData" v-model="linkUrl">
                <el-option v-for="item in portList" :value="Number(item.code)" :label="item.name">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div> -->
      </div>
    </div>
    <div class="ml20 mt20 f18 blue " v-if="this.$route.query.name">
      <div class="cursor" @click="$router.back()"><i class="el-icon-back"></i>返回</div>
    </div>
    <div class="flex ml20">
      <unitList v-show="!($store.state.user.userInfo.natureId == 1)" @select="getUnit" @getFirst="getOne"></unitList>
      <div class="flex1">
        <!-- <div class="flex">

          <div class="search-form ml20 flex printhide">
            <div class="block flex ml20 mt20">
              <el-date-picker v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
            <div class="ml10 mt20">
              <el-button type="primary" @click="searchSubmit" size="small">查询</el-button>
            </div>

          </div>
      
        </div> -->

        <div class="flex">
          <div class="search-form ml20 flex">
            <div class="block flex ml20 mt20">
              <el-form class="time-form">
                <el-col :span="12">
                  <el-form-item label="开始时间" label-width="80px" style="width:100%">
                    <el-date-picker v-model="params.starttime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择开始时间"> </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="结束时间" label-width="80px" style="width:100%">
                    <el-date-picker v-model="params.endtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择结束时间"> </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
            <div class="ml10 mt20">
              <el-button type="primary" @click="searchSubmit" size="small">查询</el-button>
            </div>
          </div>
        </div>

        <div class="f-list flex">
          <div class="flex1 flex tx-center" style="flex-wrap: wrap">
            <div id="tab1" class="tab1"></div>
            <div id="tab2" class="tab1"></div>
            <div id="tab3" class="tab1"></div>
            <div id="tab4" class="tab1"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="center mt20 printhide" style="margin-bottom:20px">
             <el-button type="primary" v-print="'#printm'">打印报表</el-button>

    </div> -->
  </div>
</template>
<script>
import echarts from 'echarts';
import { getTime } from '../../api/common.js';
import unitList from '@/components/unitList';

export default {
  components: { unitList },
  data() {
    return {
      power: 0,
      linkUrl: Number(this.$route.query.type) || 8,
      portList: [],
      value1: [], // 时间查询
      params: {
        starttime: '',
        endtime: '',
        c_company_num: this.$store.state.user.company.cCompanyNum || '',
      },
      cpNum: '',
      // oneData:[],
      oneData: [], //巡查点隐患
      fourData: [], //巡查整改情况
      twoData: [], // 巡查点位数量
      threeData: [], //巡查人员次数
    };
  },
  async created() {
    // await getTime().then((data) => {
    //   let time = data.sysTime2.replace(/-/g, "/");
    //   let timeLine = new Date(time).getTime();
    //   this.params.starttime = new Date(timeLine).Format("yyyy-MM-01 00:00:00");
    //   this.params.endtime = new Date(timeLine).Format("yyyy-MM-dd hh:mm:ss");
    // });

    this.resetTime();

    // this.getList();
  },
  watch: {
    cpNum() {
      this.$get(`/trxf/main/xf/companyInfo/getCPort/${this.$store.state.user.company.cCompanyNum || this.cpNum}`).then((res) => {
        this.portList = res.data;
      });
      this.params.c_company_num = this.cpNum;
      this.clear();
      this.getList();
    },
  },
  mounted() {},
  //     watch:{
  //     cpNum(){
  //          this.getList()
  //     }
  // },
  methods: {
    changeData() {
      var query = {};
      switch (this.linkUrl) {
        case 1:
          query = { c_num: this.cpNum, name: this.$route.query.name, type: 1 };
          break;
        case 2:
          query = { c_num: this.cpNum, name: this.$route.query.name, type: 2 };
          break;
        case 5:
          query = { c_num: this.c_num, name: this.$route.query.name, type: 5 };
          break;
        case 8:
          break;
        default:
          query = { id: this.cpNum, name: this.$route.query.name, type: this.linkUrl };
      }
      var obj = {
        1: '/score/detail',
        2: '/score/detail',
        3: '/report/report-detail',
        4: '/report/report-detail',
        5: '/score/detail',
        7: '/report/electronic-detail',
        8: '/safe/safe-statistics',
      };

      this.$router.replace({ path: obj[this.linkUrl], query }).then((res) => {
        setTimeout(() => {
          var url = this.linkUrl;
          this.reload();
          this.linkUrl = url;
        }, 100);
      });
    },
    resetTime() {
      let time = new Date(+new Date() + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace('T', ' ')
        .replace(/-/g, '/');
      let timeLine = new Date(time).getTime();
      this.params.starttime = new Date(timeLine).Format('yyyy-MM-01 00:00:00');
      this.params.endtime = new Date(timeLine).Format('yyyy-MM-dd hh:mm:ss');
    },
    getList() {
      this.getWater();
    },
    searchSubmit() {
      // function changeArr(val) {
      //   var arr = val.split(" ");
      //   var n = arr[0].replace(/['年','月']/g, "-");
      //   n = n.replace(/日/g, "");
      //   return n;
      // }
      this.clear();
      // if (this.value1.length) {
      //   this.params.starttime = this.value1[0];
      //   this.params.endtime = this.value1[1];
      // } else {
      //   this.resetTime();
      // }

      // console.log(this.params)
      // return
      //  console.log(this.params)
      this.getList();
    },
    clear() {
      (this.oneData = []), //巡查点隐患
        (this.fourData = []), //巡查整改情况
        (this.twoData = []), // 巡查点位数量
        (this.threeData = []); //巡查人员次数
    },

    async getWater() {
      function setData(res, data) {
        res.map((item) => {
          data.push({ name: item.name, value: item.data });
        });
      }
      var areaList = [];
      var personli = [];

      //巡查区域
      await this.$post('/patrol/selectarea', this.params).then((data) => {
        data.data.map((item) => {
          areaList.push(item.x_company_area);
        });
      });
      //巡查人员
      // await this.$post('/patrol/xcpersonlist')

      await this.$post('/patrol/selectjilu', this.params).then((res) => {
        if (res) {
          //处理巡查占比数据

          setData(res.data[0].one, this.oneData);

          //处理巡查点分布数据
          setData(res.data[0].four, this.fourData);

          //处理巡查整改情况
          setData(res.data[0].two, this.twoData);
          setData(res.data[0].three, this.threeData);
          res.data[0].three.map((item) => {
            personli.push(item.name);
          });
          // setData(res.data[0].three, this.threeData);
          return;
        }
        // 巡查点占比
      });

      this.makeChart(this.oneData, ['正常', '隐患'], 'tab1', '巡查点隐患占比');
      this.makeChart(this.fourData, ['待整改', '已整改', '当场整改'], 'tab3', '巡查整改情况', {
        color: [
          '#b3eeca', // 当
          '#da6b6b', // 已
          '#94aaee', // 待
        ],
      });
      this.makeLine(this.twoData, areaList, 'tab2', {
        title: '巡查区域',
        hname: '巡查点',
        sname: '数量',
        insername: '区域数量',
      });
      this.makeLine(this.threeData, personli, 'tab4', {
        title: '巡查人员频次',
        hname: '人员',
        sname: '巡查频次',
        insername: '巡查频次',
      });
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    makeLine(arr1, arr2, id, config) {
      echarts.init(document.getElementById(id)).dispose();

      var option = {
        title: {
          text: config.title,
          left: 'center',
          top: '370px',
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          data: arr2,
          name: config.hname,
          nameTextStyle: {
            fontSize: 14,
            fontFamily: 'Arial',
            fontWeight: 'bold',
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          name: config.sname,
          nameTextStyle: {
            fontSize: 14,
            fontFamily: 'Arial',
            fontWeight: 'bold',
          },
          //  max: 10000,
          // scale: false,
          // splitNumber: 10,
          // minInterval: 0
        },
        dataZoom: [
          {
            start: 2,
            type: 'inside',
          },
          {
            type: 'slider',
            start: 2,
          },
        ],
        series: {
          name: config.insername,
          type: 'bar',
          data: arr1,
          itemStyle: {
            normal: {
              show: true,
              color: '#9EB0DF',
            },
          },
          // label: {
          //   show: true,
          //   position: "top",
          //   fontSize: 18,

          //   color: "#000",
          // },
          large: true,
        },
      };
      setTimeout(() => {
        echarts.init(document.getElementById(id)).setOption(option);
      }, 100);
    },

    //饼图
    makeChart(arr, arr2, id, title, config) {
      echarts.init(document.getElementById(id)).dispose();
      var color = ['#6AB0B8 ', '#C23531', '#0240A3'];
      if (config) {
        color = config.color ? config.color : color;
      }
      // console.log(this.chartList)
      if (arr.length == 0) {
        arr.push({ value: 0, name: '暂无数据' });
      }
      let option = {
        title: {
          text: title,
          left: 'center',
          top: '370px',
        },
        color: color,
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          left: '100px',
          data: arr2,
        },
        series: [
          {
            name: '',
            title: '访问来源',
            show: true,
            type: 'pie',
            //            label: {
            //   show: true,
            //    position: 'top',
            //    fontSize: 18,

            //    color:'#000'
            // },
            radius: '60%',
            center: ['53%', '50%'],
            data: arr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      setTimeout(() => {
        echarts.init(document.getElementById(id)).setOption(option);
      }, 100);
    },
  },
};
</script>
<style scoped lang="scss">
.tab1 {
  width: 40%;
  min-height: 400px;
  margin: 20px 80px 20px 30px;
}

#line {
  height: 250px;
  width: 100%;
}

@media print {
  #tab1,
  #tab2,
  #tab3,
  #tab4 {
    margin-top: 120px;
    width: 100%;
  }

  .printhide {
    display: none;
  }

  #printm {
  }
}
.common-head-title {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 48px);
}
</style>
